import { Bookmark, BookmarkCheck } from 'lucide-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button';
import { useBookmark } from '../../hooks/useBookmark';
import { generateSlug } from '../../utils/generateSlug';

const BookmarkButtonStyled = styled(Button)`
  gap: 0.5rem;
`;

const BookmarkButton = ({ article, variant = 'secondary', size = 'sm' }) => {
  const { t } = useTranslation();
  const { isBookmarked, toggleBookmark } = useBookmark();
  const articleId = article._id || article.id;
  const slug = article.slug || generateSlug(article.title);
  const bookmarked = isBookmarked(articleId || slug);

  const handleClick = async () => {
    await toggleBookmark({
      ...article,
      _id: articleId,
      id: articleId,
      slug,
    });
  };

  return (
    <BookmarkButtonStyled
      variant={variant}
      size={size}
      onClick={handleClick}
      aria-label={bookmarked ? t('article.removeBookmark') : t('article.addBookmark')}
    >
      {bookmarked ? <BookmarkCheck /> : <Bookmark />}
      {bookmarked ? 'Saved' : 'Save'}
    </BookmarkButtonStyled>
  );
};

export default BookmarkButton;



